const defaultCurrency = 'USD';

export const currencyFormat = (
    value: number | null | undefined,
    currency: string | null | undefined = defaultCurrency,
) => {
    if (value == null || !Number.isFinite(Number(value))) {
        return '';
    }

    const currencyCode = currency?.trim().toUpperCase() || defaultCurrency;

    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    } catch {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: defaultCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    }
};
